import { lazy } from "react";

const RELOAD_FLAG = "altiv_chunk_reload_attempted";

function isChunkLoadError(err) {
  if (!err) return false;
  if (err.name === "ChunkLoadError") return true;
  const msg = String(err.message || "");
  return (
    /Loading chunk [\w-]+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /Importing a module script failed/i.test(msg)
  );
}

export default function lazyWithRetry(importer) {
  return lazy(() =>
    importer().catch((err) => {
      if (!isChunkLoadError(err)) throw err;
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          importer()
            .then(resolve)
            .catch((err2) => {
              try {
                if (!sessionStorage.getItem(RELOAD_FLAG)) {
                  sessionStorage.setItem(RELOAD_FLAG, "1");
                  window.location.reload();
                  return;
                }
              } catch {}
              reject(err2);
            });
        }, 600);
      });
    })
  );
}
